<template>
    <div class="container login-cont">
        <div class="">
            <form @submit.prevent="login()">
                <div class="form-row">
                    
                    <div class="col-md-4 offset-md-4">
                        <div class="box-bordered p-l-20 p-r-20 p-t-10 p-b-20 m-t-30">
                            <div class="title-login">Logowanie</div> 
                            <div class="m-b-30">
                                <input class="form-control" type="text" name="username" placeholder="nazwa użytkownika"
                                    v-model="username" required>
                            </div>
                            <div class="m-b-20">
                                <input class="form-control" type="password" name="password" placeholder="hasło" v-model="password"
                                    required>
                            </div>
                            <div class="text-align-r">
                                <button class="btn btn-orange" type="submit">Zaloguj się</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                username: '',
                password: '',
            }
        },
        methods: {
            login: function () {
                this.$store.dispatch('auth/login', {
                    username: this.username,
                    password: this.password,
                })
                    .catch(() => {
                        this.$vs.notify({text: 'Błędna nazwa użytkownika lub hasło', color: 'danger'})
                    });
            },
        }
    }
</script>

<style lang="scss" scoped>
    
    .title-login {
        font-size: 1.2rem;
        font-weight: 500;
        color: #235ba6; 
        margin-bottom: .5rem;       
    }
</style>


// WEBPACK FOOTER //
// Login.vue?c9780b9e